import {TOGGLE_DRAWER, CLOSE_DRAWER} from '../actions'
import {LOCATION_CHANGE} from 'react-router-redux'

const initialState = {
    drawerOpen: false,
    showMenu: false,
    showHeader: false,
}

const ROUTES_TO_HIDE_MENU = ['/login', '/register']
const ROUTES_TO_HIDE_HEADER = ['/login']

const site = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_DRAWER:
            return {
                ...state,
                drawerOpen: !state.drawerOpen
            }
        case CLOSE_DRAWER:
            return {
                ...state,
                drawerOpen: false
            }
        case LOCATION_CHANGE:
            return {
                ...state,
                showMenu: ROUTES_TO_HIDE_MENU.indexOf(action.payload.pathname) === -1,
                showHeader: ROUTES_TO_HIDE_HEADER.indexOf(action.payload.pathname) === -1,
                showFooter: ROUTES_TO_HIDE_HEADER.indexOf(action.payload.pathname) === -1,
                drawerOpen: false
            }
        default:
            return state
    }
}

export default site



// WEBPACK FOOTER //
// ./src/reducers/site.js